
import { CustomSearch } from '@/shared/components/ui';
import { useGetFetchCodigoOtpSupervisor } from '@/shared/actions/erp';
import { useCheckPermissions, useTableFilter } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { IDataCodigoOtp } from '@/shared/interfaces';
import { Grid } from '@mui/material';
import { useColumsTableOTPSupervisor } from '@/erp/codigos-otp/shared/hooks';
import { formatDate } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';


export default function SolicitudOtpExpiradoPage() {

  useCheckPermissions(PermissionsEnum.api_view_codigootp);

  //HOOK PERSONALIZADO
  const { columnsOtpSupervisor } = useColumsTableOTPSupervisor();

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter
  } = useTableFilter();


  const { pageIndex } = pagination;

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetFetchCodigoOtpSupervisor(
      {
        page: pageIndex + 1,
        codigo: searchTerm,
        fecha_hora_expiracion: formatDate(new Date)
      }
    );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<IDataCodigoOtp>
          columns={columnsOtpSupervisor}
          data={preventasRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={preventasRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          canDelete={false}
          positionActionsColumn='first'

          enableColumnActions={false}
          enableEditing={false}
          canEdit={false}
        />
      </Grid>
    </Grid>
  );


}

